export const drawerWidth = 240;
export const pageMaxWidth = 1324;
